<template>
    <NuPointSprayManagement>
    </NuPointSprayManagement>
</template>

<script>
import NuPointSprayManagement from '@/components/nuPointSpray/NuPointSprayJobManagement.vue'

export default {
    components: {
        NuPointSprayManagement
    }
}
</script>